"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "teano": {
    "db1fc115": [{
      "hkey": "ad177a2d",
      "slug": "borgonuovo",
      "name": "Borgonuovo",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-nuovo": [{
      "hkey": "ad177a2d",
      "slug": "borgonuovo",
      "name": "Borgonuovo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c874f1dc": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "skipSearch": false
    }],
    "campo-faio": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "57037e4f": [{
      "hkey": "7daf8645",
      "slug": "casamostra-casi",
      "name": "Casamostra-Casi",
      "primary": true,
      "skipSearch": false
    }],
    "casi": [{
      "hkey": "7daf8645",
      "slug": "casamostra-casi",
      "name": "Casamostra-Casi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fab51817": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "skipSearch": false
    }],
    "fontana-regina": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "005495aa": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "skipSearch": false
    }],
    "grafevola": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "91fdbe1d": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "skipSearch": false
    }],
    "loreto": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0951ba14": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "skipSearch": false
    }],
    "montelucino": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "751e0799": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "skipSearch": false
    }],
    "orto-ceraso": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c54bcf5f": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "skipSearch": false
    }],
    "passerelle": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c9e8e733": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "skipSearch": false
    }],
    "ruozzo": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "780abf84": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "skipSearch": false
    }],
    "san-lieno": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "79897dd9": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "skipSearch": false
    }],
    "soppegna": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d3279435": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "skipSearch": false
    }],
    "terragnano": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dc7248a8": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "skipSearch": false
    }],
    "torricelle": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "13bcb670": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "skipSearch": false
    }],
    "valleranno": [{
      "hkey": "42e477db",
      "slug": "teano",
      "name": "Teano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;